import { TestableComponent } from 'common/interfaces';
import { getScalablePixel } from 'common/utils';
import React from 'react';

interface MenuSelectorProps extends TestableComponent {
  width?: number;
  position?: number;
}
function MenuSelector({
  width,
  position,
  children,
  testId
}: React.PropsWithChildren<MenuSelectorProps>) {
  const transform = `translate3d(${getScalablePixel(position || 0)}px, 0px, 0px) scaleX(${width})`;
  return (
    <div className="menu-selector" data-test-id={testId} style={{ transform }}>
      {children}
    </div>
  );
}

export default React.memo(MenuSelector);
